import { MultiValueProps } from 'react-select';
import { MoreSelectedBadge } from './styles';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { Box } from '@/components/Box/Box';

type MultiSelectValueType = MultiValueProps & {
  placeholderValue?: string;
};

export const MultiSelectValue = ({ placeholderValue = 'Selected Values', ...props }: MultiSelectValueType) => {
  const MAX_COUNT_TO_SHOW = 1;
  const itemsCount = props.getValue().length;

  if (props?.index < MAX_COUNT_TO_SHOW) {
    return (
      <Box display='flex' alignItems='center' columnGap='8px'>
        <Typography variant='bodySmall' color={COLORS.black} fontWeight='regular'>
          {placeholderValue}
        </Typography>
        <MoreSelectedBadge>{itemsCount}</MoreSelectedBadge>
      </Box>
    );
  }

  return null;
};
